import { defineComponent as l, openBlock as r, createBlock as a, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconClock",
  __name: "IconClock",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (m, e) => (r(), a(p(i), c(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", { d: "M12.75 6.5a.75.75 0 0 0-1.5 0v5.293a1.25 1.25 0 0 0 .366.884l2.354 2.353a.75.75 0 1 0 1.06-1.06l-2.28-2.28V6.5" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 1 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
